import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel } from '@coreui/react'
import { Spinner } from 'react-bootstrap'

import { CalendarDays, Files } from 'lucide-react'

const PastOrder = ({ patientID, noteID, headerShow = true, noteStructureRef }) => {
  const [ordersData, setOrdersData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [showOrderPopUp, setShowOrderPopUp] = useState(false)
  const [file, setFile] = useState([])
  const GetPatientTreatmentsNotes = async () => {
    setIsPageLoading(true)
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data.map((item) => {
          return {
            ...item,
            data: item.data ? JSON.parse(item?.data) : {},
          }
        })

        if (noteID > 0) {
          let orders = data[parseInt(noteID) - 1]?.data?.plans
        }

        // setPatientTreatments(data);

        return data
      }
    } catch (error) {
      console.error('error in patient treatment', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const fetchOrders = async () => {
    setIsPageLoading(true)
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []
      const parsedOrders = data
        ?.map((order) => ({
          // ...order,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

      setOrders(parsedOrders)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleScript = (file) => {
    setFile(file)
    setShowOrderPopUp(true)
  }

  useEffect(() => {
    fetchOrders()
  }, [])
  return (
    <div className=" ">
      <h5 style={{ display: headerShow ? 'block' : 'none' }}>Previous Order</h5>

      {isPageLoading ? (
        <div className="text-center">
          {' '}
          <Spinner />{' '}
        </div>
      ) : (
        <div>
          {orders?.length > 0 ? (
            orders.map((item, idx) => {
              const currentOrder = item?.medication
              return (
                <div key={idx} className="mb-3">
                  <div className="card shadow-sm bg-secondary">
                    <div className="card-body">
                      {/* Date */}
                      <div className="">
                        <div>
                          <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                          {(() => {
                            if (!item?.date) return
                            const parts = item?.date?.split('-')
                            if (!parts || parts.length !== 3) return ''
                            const [month, day, year] = parts
                            const date = new Date(`${year}-${month}-${day}`)
                            return new Intl.DateTimeFormat('en-US', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                            }).format(date)
                          })()}
                        </div>
                        {currentOrder?.diagnosis && (
                          <p className="mb-1 " style={{ marginTop: '-8px' }}>
                            <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                          </p>
                        )}
                      </div>
                      {noteStructureRef?.current?.freeTypesEverything?.OrderFreeType?.[currentOrder.diagnosis] ? (
                        <div className=" ">
                          <textarea style={{ width: '100%', height: '200px', border: 'none' }} className="bg-secondary card-body" value={noteStructureRef?.current?.freeTypesEverything?.OrderFreeType?.[currentOrder.diagnosis] || ''} readOnly />
                        </div>
                      ) : (
                        <div>
                          {/* free type  */}

                          {/* Imaging */}
                          {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                            <div className="mb-2">
                              <p className="text-secondary fw-bold mb-1">Imaging</p>
                             <ul className="p-0 m-2">
  {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => {
    const type = imagingItem?.type
    const reason = imagingItem?.reason
    const code = imagingItem?.code

    return (
      <li className="p-0 m-0" key={iIdx}>
        {type && (
          <div>
            {type}
          </div>
        )}

        {reason && (
          <div className="ms-3">
            Reason: {reason}
          </div>
        )}

       

        {imagingItem?.script?.length > 0 && (
          <span
            className="mb-1 mx-2"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleScript(imagingItem.script)
            }}
          >
            <Files size={14} />
          </span>
        )}
      </li>
    )
  })}
</ul>
                            </div>
                          )}

                          {/* Labs */}
                          {currentOrder?.lab?.labs?.length > 0 && (
                            <div className="mb-2">
                              <p className="text-secondary fw-bold mb-1">Labs</p>
                           <ul className="p-0 m-2">
  {currentOrder.lab.labs.map((labItem, lIdx) => {
    const lab = labItem?.lab
    const reason = labItem?.reason
   // const code = labItem?.code

    return (
      <li className="p-0 m-0" key={lIdx}>
        {lab && (
          <div>
            Labs: {lab}
          </div>
        )}

        {reason && (
          <div className="ms-3">
            Reason: {reason}
          </div>
        )}


        {labItem?.script?.length > 0 && (
          <span
            className="mb-1 mx-2"
            style={{ cursor: 'pointer' }}
            onClick={() => handleScript(labItem.script)}
          >
            <Files size={14} />
          </span>
        )}
      </li>
    )
  })}
</ul>
                            </div>
                          )}

                          {/* Medications */}
                          {currentOrder?.medication?.medication?.length > 0 && (
                            <div className="mb-2">
                              <p className="text-secondary fw-bold mb-1">Medications</p>
                            <ul className="p-0 m-2">
  {currentOrder.medication.medication.map((medItem, mIdx) => {
    const name = medItem?.name
    const dosage = medItem?.dosage
    const route = medItem?.route
    const frequency = medItem?.frequency
    const reason = medItem?.reason
   // const code = medItem?.code

    return (
      <li className="p-0 m-0" key={mIdx}>
        {(name || dosage || route || frequency) && (
          <div>
            {name}
            {dosage && ` ${dosage}`}
            {route && ` ${route}`}
            {frequency && ` ${frequency}`}
          </div>
        )}

        {reason && (
          <div className="ms-3">
            Reason: {reason}
          </div>
        )}

     

        {medItem?.script?.length > 0 && (
          <span
            className="mb-1 mx-2"
            style={{ cursor: 'pointer' }}
            onClick={() => handleScript(medItem.script)}
          >
            <Files size={14} />
          </span>
        )}
      </li>
    )
  })}
</ul>
                            </div>
                          )}

                          {/* Miscellaneous */}
                          {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                            <div className="mb-2">
                              <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                              <ul>
                                {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                  <li className="p-0 m-0" key={xIdx}>
                                    {miscItem.type}
                                    {miscItem?.script.length > 0 ? (
                                      <span
                                        className="mb-1 mx-2"
                                        onClick={() => {
                                          handleScript(miscItem?.script)
                                        }}
                                      >
                                        <Files size={14} />
                                      </span>
                                    ) : (
                                      ''
                                    )}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <div className="text-center text-muted py-3">No orders available.</div>
          )}
        </div>
      )}

      <CModal size="md" backdrop="static" visible={showOrderPopUp} onClose={() => setShowOrderPopUp(false)}>
        <CModalHeader>
          <CModalTitle>Order Script</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ height: '300px', overflow: 'auto' }}>
          <div className="d-flex flex-wrap gap-3">
            {file?.map((fileUrl, fileIdx) => {
              const extension = fileUrl.split('.').pop()?.toLowerCase()

              const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
              const isVideo = ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
              const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)

              return (
                <div key={fileIdx} className="d-flex flex-column gap-2 align-items-center">
                  <a
                    href={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shadow rounded p-2 position-relative d-block"
                    style={{
                      width: '100px',
                      height: '100px',
                      overflow: 'hidden',
                      borderRadius: '8px',
                      cursor: 'pointer',

                      textDecoration: 'none',
                    }}
                  >
                    {isVideo ? (
                      <video
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '8px',
                        }}
                        controls
                      >
                        <source src={fileUrl} type="video/mp4" />
                      </video>
                    ) : isImage ? (
                      <img
                        src={fileUrl}
                        alt="Uploaded"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '8px',
                        }}
                      />
                    ) : isDocument ? (
                      <iframe
                        src={fileUrl}
                        title="Document Viewer"
                        style={{
                          width: '100%',
                          height: '100%',
                          border: 'none',
                          borderRadius: '8px',
                          pointerEvents: 'none',
                        }}
                      />
                    ) : (
                      <div
                        className="text-center"
                        style={{
                          color: '#fff',
                          fontSize: '0.75rem',
                          padding: '10px',
                        }}
                      >
                        Unknown File
                      </div>
                    )}
                  </a>
                </div>
              )
            })}
          </div>
        </CModalBody>

        <CModalFooter className="mt-2">
          <CButton onClick={() => setShowOrderPopUp(false)} variant="outline" color="secondary">
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default PastOrder
